import { TherapistWorkingInfoResponseDtoWorkWithReligionsEnum } from '@app/api';
import { COLORS, VARS } from '@app/constants';
import { FilterInputType, UserGenderLabels } from '@app/types';
import { Check } from '@app/ui/iconComponents';
import { DayLimitEnum } from './types';
import { UserGender } from '../TherapistDetailsPage/types';

export type AdditionalFilter = {
  name: string;
  title: string;
} & (
  | {
      options: AdditionalFilterOptions[] | string[];
      inputType: FilterInputType.Radio;
    }
  | {
      options: AdditionalFilterOptions[] | string[];
      inputType?: FilterInputType.Checkbox;
    }
  | {
      options: AdditionalFilterOptions[] | [string];
      inputType: FilterInputType.Switch;
    }
  | {
      options: [number, number];
      inputType: FilterInputType.Slider;
      defaultValue?: [number];
    }
  | {
      inputType: FilterInputType.Range;
    }
  | {
    inputType: FilterInputType.RangeSecond;
  }
);

export type AdditionalFilterOptions = {
  name: string;
  id?: string | number | boolean | undefined;
  url?: string;
  tip?: string;
};

export const additionalFilters: AdditionalFilter[] = [
  {
    name: 'gender',
    title: 'Пол специалиста',
    options: [
      {
        id: UserGender.MALE,
        name: UserGenderLabels.MALE,
      },
      {
        id: UserGender.FEMALE,
        name: UserGenderLabels.FEMALE,
      },
      {
        id: UserGender.ANY,
        name: UserGenderLabels.ANY,
      },
    ],
    inputType: FilterInputType.Radio,
  },
  {
    name: 'workWithLgbt',
    title: 'Опыт работы с LGBT',
    options: [{ id: true, name: 'Есть опыт' }],
  },
  {
    name: 'dayLimit',
    title: 'Ближайшая дата',
    options: [
      {
        id: 1,
        name: DayLimitEnum.Today,
      },
      {
        id: 3,
        name: DayLimitEnum.ThreeDays,
      },
      {
        id: 7,
        name: DayLimitEnum.Week,
      },
      {
        id: 30,
        name: DayLimitEnum.Month,
      },
      {
        id: 'any',
        name: DayLimitEnum.NoMatter,
      },
    ],
    inputType: FilterInputType.Radio,
  },
  {
    name: 'priceMax',
    title: 'Стоимость сессии',
    inputType: FilterInputType.Slider,
    options: [VARS.minSessionPrice, VARS.maxSessionPrice],
    defaultValue: [VARS.maxSessionPrice],
  },
  {
    name: 'workWithEthnicGroups',
    title: 'Работа с этническими группами',
    options: [{ id: true, name: 'Есть опыт' }],
  },
  {
    name: 'religions',
    title: 'Религиозная направленность',
    options: [
      {
        id: TherapistWorkingInfoResponseDtoWorkWithReligionsEnum.Christianity,
        name: VARS.russianTranslateReligions[
          TherapistWorkingInfoResponseDtoWorkWithReligionsEnum.Christianity
        ],
      },

      {
        id: TherapistWorkingInfoResponseDtoWorkWithReligionsEnum.Islamism,
        name: VARS.russianTranslateReligions[
          TherapistWorkingInfoResponseDtoWorkWithReligionsEnum.Islamism
        ],
      },

      {
        id: TherapistWorkingInfoResponseDtoWorkWithReligionsEnum.Buddhism,
        name: VARS.russianTranslateReligions[
          TherapistWorkingInfoResponseDtoWorkWithReligionsEnum.Buddhism
        ],
      },

      {
        id: TherapistWorkingInfoResponseDtoWorkWithReligionsEnum.Judaism,
        name: VARS.russianTranslateReligions[
          TherapistWorkingInfoResponseDtoWorkWithReligionsEnum.Judaism
        ],
      },
    ],
  },
  // {
  //   name: 'isApproved',
  //   title: VARS.approvedTherapistLabel,
  //   options: [{ id: true, name: 'isApproved' }],
  //   inputType: FilterInputType.Switch,
  // },
];

export const filterIcons = [
  {
    icon: <Check color={COLORS.blue400} />,
    name: 'isApproved',
    tooltip: VARS.approvedTherapistLabelDescription,
  },
];

export const filterTooltips = [
  {
    name: 'Проблемы с ребенком/подростком',
    tooltip:
      'Консультация одного либо обоих родителей  по проблемам коммуникации с ребенком в формате вопрос-ответ у опытного специалиста в течение 50 минут',
  },
];
